import React, { Component } from 'react';

import HelpfulInfoChildPageBase from '../HelpfulInfoChildPageBase';

interface OwnProps {}
interface OwnState {}

class Etransfer extends Component<OwnProps, OwnState> {
  render() {
    return <HelpfulInfoChildPageBase pageID={1262} />;
  }
}
export default Etransfer;
